<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col-1-1">
    </div>
    <div class="col-2"></div>
    <div class="col-3 bold">
      Huidige periode
    </div>
    <div class="col-4 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="tradeReceivablesFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Vorderingen op handelsdebiteuren</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesGroupCompaniesCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen op groepsmaatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(2)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesOtherAffiliatedCompaniesCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen op overige verbonden maatschappijen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(3)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="receivablesShareholdersParticipatingInterestsCurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in
            de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit"}} een deelneming heeft</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(4)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="calledUpShareCapitalFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Opgevraagde stortingen van geplaatst kapitaal</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(51)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <div class="row">
      <div class="col-1-1"><p style="padding: 6px"><b>Overige kortlopende vorderingen</b></p></div>
    </div>
    <form [formGroup]="pensionReceivablesReceivablesOtherCurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px">Pensioenvordering</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(52)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding-left: 10px">Vorderingen uit hoofde van leningen en voorschotten aan leden of houders van
              aandelen op naam</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(5)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    @if (isRechtspersoon) {
      <form [formGroup]="loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding-left: 10px">Kortlopende leningen, voorschotten en garanties ten behoeve van
              bestuurders</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(61)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    @if (isRechtspersoon) {
      <form [formGroup]="loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding-left: 10px">Kortlopende leningen, voorschotten en garanties ten behoeve van
              commissarissen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(62)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="otherReceivablesOtherCurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px">Andere overige vorderingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(6)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="receivablesOtherCurrentFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px"><b>Totaal van overige kortlopende vorderingen</b></p>
        </div>
        <div class="col-2">

        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="receivablesIncomeTaxFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Vorderingen uit belastingen naar de winst</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(71)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <form [formGroup]="taxReceivablesFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px">Belastingvorderingen (overige)</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(7)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    @if (isRechtspersoon) {
      <form [formGroup]="deferredTaxAssetsCurrentFg">
        <div class="row">
          <div class="col-1-1">
            <p style="padding: 6px">Latente belastingvorderingen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-button type="secondary"
                                 icon="plus"
                                 class="custom-input-150"
                                 (click)="this.showDialog(8)">Specificeer
            </snelstart-ui-button>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                              class="custom-input-150 custom-readonly"
                                              align="right"
                                              prefix="€"
                                              [showAllDecimals]="false"
                                              [disabledControl]="true"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </form>
    }
    <div class="row">
      <div class="col-1-1"><p style="padding: 6px"><b>Overlopende activa</b></p></div>
    </div>
    <form [formGroup]="pensionReceivablesReceivablesAccruedIncomeFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px">Pensioenvordering overlopende activa</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(91)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="accruedIncomeOtherFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px">Overige overlopende activa</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(9)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="accruedIncomeFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding-left: 10px"><b>Totaal van overlopende activa</b></p>
        </div>
        <div class="col-2">

        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="receivablesFg">
      <div class="row">
        <div class="col-1-1">
          <p style="padding: 6px"><b>Totaal van vorderingen</b></p>
        </div>
        <div class="col-2">

        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="receivablesDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vorderingen</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(11)">
          {{ this.receivablesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="tradeReceivablesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vorderingen op handelsdebiteuren</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.tradeReceivablesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(12)">
          {{ this.tradeReceivablesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesGroupCompaniesCurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen op groepsmaatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesGroupCompaniesCurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(13)">
            {{ this.receivablesGroupCompaniesCurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesOtherAffiliatedCompaniesCurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen op overige verbonden maatschappijen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(14)">
            {{ this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="receivablesShareholdersParticipatingInterestsCurrentDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vorderingen op andere rechtspersonen en vennootschappen die
          een deelneming hebben in de {{ isRechtspersoon ? "rechtspersoon of waarin de rechtspersoon" : "entiteit of waarin de entiteit"}} een deelneming heeft</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(15)">
          {{ this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="pensionReceivablesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over pensioenvordering</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.pensionReceivablesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(16)">
          {{ this.pensionReceivablesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="receivablesIncomeTaxDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over vorderingen uit belastingen naar de winst</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.receivablesIncomeTaxDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(17)">
            {{ this.receivablesIncomeTaxDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="taxReceivablesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over belastingvorderingen (overige)</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.taxReceivablesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(18)">
          {{ this.taxReceivablesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  @if (isRechtspersoon) {
    <form [formGroup]="deferredTaxAssetsCurrentDisclosureFg">
      <div class="row">
        <div class="col col-1" style="width: 400px">
          <p style="padding: 6px">Informatieverschaffing over latente belastingvorderingen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="{{ this.deferredTaxAssetsCurrentDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                               class="custom-input-150"
                               (click)="this.showDialog(19)">
            {{ this.deferredTaxAssetsCurrentDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
          </snelstart-ui-button>
        </div>
        @if (isRechtspersoon) {
          <div class="col-3">
            <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                              [options]="this.optionsJaNee"
                                              [required]=true
                                              class="me-1 custom-input-150"
                                              (change)="this.saveForm()"
            >
            </snelstart-ui-select-form-control>
          </div>
        }
      </div>
    </form>
  }
  <form [formGroup]="accruedIncomeDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over overlopende activa</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.accruedIncomeDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(20)">
          {{ this.accruedIncomeDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="receivablesMaturityExceedingOneYearDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vorderingen met een looptijd langer dan een jaar</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.receivablesMaturityExceedingOneYearDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(21)">
          {{ this.receivablesMaturityExceedingOneYearDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.tradeReceivablesFg"
                                                       [title]="'vorderingen op handelsdebiteuren'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesGroupCompaniesCurrentFg"
                                                       [title]="'vorderingen op groepsmaatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesOtherAffiliatedCompaniesCurrentFg"
                                                       [title]="'vorderingen op overige verbonden maatschappijen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesShareholdersParticipatingInterestsCurrentFg"
                                                       [title]="`vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg"
                                                       [title]="'vorderingen uit hoofde van leningen en voorschotten aan leden of houders van aandelen op naam'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 51">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.calledUpShareCapitalFg"
                                                       [title]="'opgevraagde stortingen van geplaatst kapitaal'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 52">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.pensionReceivablesReceivablesOtherCurrentFg"
                                                       [title]="'pensioenvordering'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 61">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg"
                                                       [title]="'kortlopende leningen, voorschotten en garanties ten behoeve van bestuurders'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 62">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg"
                                                       [title]="'kortlopende leningen, voorschotten en garanties ten behoeve van commissarissen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.otherReceivablesOtherCurrentFg"
                                                       [title]="'andere overige vorderingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.taxReceivablesFg"
                                                       [title]="'belastingvorderingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 71">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.receivablesIncomeTaxFg"
                                                       [title]="'vorderingen uit belastingen naar de winst'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.deferredTaxAssetsCurrentFg"
                                                       [title]="'latente belastingvorderingen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 91">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.pensionReceivablesReceivablesAccruedIncomeFg"
                                                       [title]="'pensioenvordering overlopende activa'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.accruedIncomeOtherFg"
                                                       [title]="'overlopende activa'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

<div *ngIf="this.index === 11">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 12">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.tradeReceivablesDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen op handelsdebiteuren'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 13">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesGroupCompaniesCurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen op groepsmaatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 14">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen op overige verbonden maatschappijen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 15">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg"
                                                               [title]="`Informatieverschaffing over kortlopende vorderingen op andere rechtspersonen en vennootschappen die een deelneming hebben in de ${isRechtspersoon ? 'rechtspersoon of waarin de rechtspersoon' : 'entiteit of waarin de entiteit'} een deelneming heeft`"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 16">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.pensionReceivablesDisclosureFg"
                                                               [title]="'Informatieverschaffing over pensioenvordering'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 17">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesIncomeTaxDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen uit belastingen naar de winst'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 18">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.taxReceivablesDisclosureFg"
                                                               [title]="'Informatieverschaffing over belastingvorderingen (overige)'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 19">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.deferredTaxAssetsCurrentDisclosureFg"
                                                               [title]="'Informatieverschaffing over latente belastingvorderingen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 20">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.accruedIncomeDisclosureFg"
                                                               [title]="'Informatieverschaffing over overlopende activa'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 21">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.receivablesMaturityExceedingOneYearDisclosureFg"
                                                               [title]="'Informatieverschaffing over vorderingen met een looptijd langer dan een jaar'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
